import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import Topbar from '../mini-comp/Topbar'
import Sidebar from '../mini-comp/Sidebar'
import API_BASE_URL from '../../../config/api'
import axios from 'axios'
import { FaCalendar, FaUsers, FaCheck, FaClock, FaEye,  } from 'react-icons/fa6'
import { FaPencilAlt } from 'react-icons/fa'

const ImmediateManagerDashboard = () => {
  const navigate = useNavigate()
  const [dashboardData, setDashboardData] = useState({
    department_employees: 12,
    leave_requests: 25,
    approved_leaves: 15,
    pending_leaves: 8,
    rejected_leaves: 2,
    next_holiday: {
      name: "Independence Day",
      date: "2026-04-18",
      type: "fixed"
    },
    recent_leaves: [
      {
        id: 105,
        employee_name: "Alice Johnson",
        leave_type: "vacation",
        start_date: "2026-02-01",
        end_date: "2026-02-10",
        status: "pending",
        duration: 7
      },
      {
        id: 102,
        employee_name: "Bob Smith",
        leave_type: "sick",
        start_date: "2026-01-20",
        end_date: "2026-01-22",
        status: "approved",
        duration: 3
      }
    ],
    employees_born_today: [
      {
        id: 5,
        employee_id: "EMP005",
        first_name: "Charlie",
        last_name: "Brown",
        email: "charlie.brown@example.com",
        department: {
          id: 2,
          name: "Sales"
        },
        position: "Sales Executive",
        date_of_birth: "1990-01-27"
      }
    ]
  })
  const [subscribedModules, setSubscribedModules] = useState([])
  const [selectedLeave, setSelectedLeave] = useState(null)

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  useEffect(() => {
    const modulesCookie = Cookies.get('subscribedModules')
    if (modulesCookie) {
      try {
        const modules = JSON.parse(modulesCookie)
        setSubscribedModules(modules)
      } catch (error) {
        console.error('Error parsing modules cookie:', error)
      }
    }
  }, [])

  const hasModule = (moduleName) => {
    return subscribedModules.some(m =>
      (m.name || m.module_name || '').toLowerCase().includes(moduleName.toLowerCase())
    )
  }

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${API_BASE_URL}/api/v1/employees/manager-dashboard`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        })
        setDashboardData(response.data)
      } catch (error) {
        console.error('Error fetching dashboard stats:', error)
      }
    }

    fetchDashboardData()
  }, [])

  return (
    <div>
      <Topbar />
      <Sidebar />

      <div className="app-content-area">
        <div className="app-content-wrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                <div className="card">
                  <div className="card-body mini-card-body d-flex align-center gap-16">
                    <div className="avatar avatar-xl bg-info-transparent text-info">
                      <FaUsers />
                    </div>
                    <div className="card-content">
                      <span className="d-block fs-16 mb-5">Dept. Employees</span>
                      <h2 className="mb-5">{dashboardData.department_employees}</h2>
                      <span className="text-info">Team Size</span>
                    </div>
                  </div>
                </div>
              </div>
              {hasModule('Leave') && (
                <>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                    <div className="card">
                      <div className="card-body mini-card-body d-flex align-center gap-16">
                        <div className="avatar avatar-xl bg-primary-transparent text-primary">
                          <FaCalendar />
                        </div>
                        <div className="card-content">
                          <span className="d-block fs-16 mb-5">Leave Requests</span>
                          <h2 className="mb-5">{dashboardData.leave_requests}</h2>
                          <span className="text-primary">Total Received</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                    <div className="card">
                      <div className="card-body mini-card-body d-flex align-center gap-16">
                        <div className="avatar avatar-xl bg-success-transparent text-success">
                          <FaCheck />
                        </div>
                        <div className="card-content">
                          <span className="d-block fs-16 mb-5">Approved Leaves</span>
                          <h2 className="mb-5">{dashboardData.approved_leaves}</h2>
                          <span className="text-success">Processed</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                    <div className="card">
                      <div className="card-body mini-card-body d-flex align-center gap-16">
                        <div className="avatar avatar-xl bg-warning-transparent text-warning">
                          <FaClock />
                        </div>
                        <div className="card-content">
                          <span className="d-block fs-16 mb-5">Pending Action</span>
                          <h2 className="mb-5">{dashboardData.pending_leaves}</h2>
                          <span className="text-warning">Require Attention</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {hasModule('Payroll') && (
                <>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                    <div className="card">
                      <div className="card-body mini-card-body d-flex align-center gap-16">
                        <div className="avatar avatar-xl bg-primary-transparent text-primary">
                          <FaCalendar />
                        </div>
                        <div className="card-content">
                          <span className="d-block fs-16 mb-5">Leave Requests</span>
                          <h2 className="mb-5">{dashboardData.payroll_requests}</h2>
                          <span className="text-primary">Total Received</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                    <div className="card">
                      <div className="card-body mini-card-body d-flex align-center gap-16">
                        <div className="avatar avatar-xl bg-success-transparent text-success">
                          <FaCheck />
                        </div>
                        <div className="card-content">
                          <span className="d-block fs-16 mb-5">Approved Leaves</span>
                          <h2 className="mb-5">{dashboardData.approved_payroll_requests}</h2>
                          <span className="text-success">Processed</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                    <div className="card">
                      <div className="card-body mini-card-body d-flex align-center gap-16">
                        <div className="avatar avatar-xl bg-warning-transparent text-warning">
                          <FaClock />
                        </div>
                        <div className="card-content">
                          <span className="d-block fs-16 mb-5">Pending Action</span>
                          <h2 className="mb-5">{dashboardData.pending_payroll_requests}</h2>
                          <span className="text-warning">Require Attention</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="row">
              {hasModule('Leave') && (
                <div className="col-xl-6">
                  <div className="card custom-card overflow-hidden">
                    <div className="card-header justify-content-between">
                      <div className="card-title">Next Upcoming Holiday</div>
                    </div>
                    <div className="card-body mt-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="avatar avatar-lg bg-primary-transparent text-primary radius-10">
                          <FaCalendar />
                        </div>
                        <div className="ms-3">
                          <h5 className="mb-0">{dashboardData.next_holiday.name}</h5>
                          <p className="text-muted mb-0">{new Date(dashboardData.next_holiday.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="badge bg-dark-subtle text-dark">{dashboardData.next_holiday.type} Holiday</span>
                        <span className="text-primary fw-semibold">Upcoming</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {hasModule('Payroll') && (
                <div className="col-xl-6">
                  <div className="card custom-card overflow-hidden">
                    <div className="card-header justify-content-between">
                      <div className="card-title">Next Upcoming Holiday</div>
                    </div>
                    <div className="card-body mt-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="avatar avatar-lg bg-primary-transparent text-primary radius-10">
                          <FaCalendar />
                        </div>
                        <div className="ms-3">
                          <h5 className="mb-0">{dashboardData.next_holiday.name}</h5>
                          <p className="text-muted mb-0">{new Date(dashboardData.next_holiday.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="badge bg-dark-subtle text-dark">{dashboardData.next_holiday.type} Holiday</span>
                        <span className="text-primary fw-semibold">Upcoming</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-xl-6">
                <div className="card custom-card">
                  <div className="card-header">
                    <div className="card-title">Today's Birthdays 🎂</div>
                  </div>
                  <div className="card-body">
                    {dashboardData.employees_born_today.length > 0 ? (
                      <ul className="list-group list-group-flush">
                        {dashboardData.employees_born_today.map((emp) => (
                          <li key={emp.id} className="list-group-item d-flex align-items-center border-0 px-0">
                            <div className="avatar avatar-md radius-100 bg-primary-transparent text-primary me-3 text-uppercase">
                              {emp.first_name[0]}{emp.last_name[0]}
                            </div>
                            <div className="flex-grow-1">
                              <h6 className="mb-0">{emp.first_name} {emp.last_name}</h6>
                              <span className="text-muted fs-12">{emp.position} - {emp.department.name}</span>
                            </div>
                            <span className="badge bg-label-primary">Happy Birthday!</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-muted mb-0">No birthdays today.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {hasModule('Leave') && (
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header justify-between">
                      <h4 className="d-flex-items gap-10">Recent Leave Requests <span className="badge bg-label-primary">{dashboardData.recent_leaves.length}</span></h4>
                    </div>
                    <div className="card-body pt-15">
                      <div className="table-responsive">
                        <table className="table w-100 text-nowrap" id="employeeAttendanceTable">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Employee</th>
                              <th>Leave Type</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Days</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dashboardData.recent_leaves.map((leave) => (
                              <tr key={leave.id}>
                                <td>{leave.id}</td>
                                <td>{leave.employee_name}</td>
                                <td className="text-capitalize">{leave.leave_type}</td>
                                <td>{new Date(leave.start_date).toLocaleDateString()}</td>
                                <td>{new Date(leave.end_date).toLocaleDateString()}</td>
                                <td>{leave.duration}</td>
                                <td>
                                  <span className={`badge bg-label-${leave.status === 'approved' ? 'success' : leave.status === 'pending' ? 'warning' : 'danger'}`}>
                                    {leave.status.charAt(0).toUpperCase() + leave.status.slice(1)}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex-items gap-10">
                                    <button className="btn-icon btn-success-light" type="button" data-bs-toggle="modal" data-bs-target="#viewLeaves" onClick={() => setSelectedLeave(leave)}>
                                      <FaEye />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {hasModule('Leave') && (
              <>
                { /* create leaves model start */}
                <div className="modal fade" id="addNewLeaves" tabIndex={-1} aria-labelledby="addNewLeavesLabel" aria-hidden="true">
                  {/* ... contents ... */}
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-16" id="addNewLeavesLabel">Add New Leaves</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                      </div>
                      <div className="modal-body">
                        <div className="row gy-15">
                          <div className="col-xl-12">
                            <div className="text-center">
                              <div className="avatar avatar-xxl radius-100">
                                <img src="assets/images/avatar/avatar-thumb-dummy.png" alt="Employee Photo" id="profileImage" className="radius-100" />
                                <span className="badge rounded-pill bg-primary avatar-badge">
                                  <input type="file" name="photo" className="p-absolute z-3 cursor-pointer w-100 h-100 op-0 pl-0 pr-0" id="profileImageChange" />
                                  <i className="ri-camera-line p-relative z-1" />
                                </span>
                              </div>
                              <span className="d-block fw-5 text-muted">Employee Photo</span>
                            </div>
                          </div>

                          <div className="col-xl-12">
                            <label htmlFor="employeeSelect" className="form-label">Employee</label>
                            <select className="employeeList form-control" id="employeeSelect">
                              <option value="p-1">John Doe (EMP-1001)</option>
                              <option value="p-2">Jane Smith (EMP-1002)</option>
                              <option value="p-3">Sarah Johnson (EMP-1003)</option>
                              <option value="p-4">Michael Brown (EMP-1004)</option>
                              <option value="p-5">Emily Davis (EMP-1005)</option>
                              <option value="p-6">Robert Wilson (EMP-1006)</option>
                            </select>
                          </div>

                          <div className="col-xl-6">
                            <label htmlFor="leaveType" className="form-label">Leave Type</label>
                            <select className="form-select" id="leaveType">
                              <option selected={true} disabled={true}>Select Leave Type</option>
                              <option>Annual Leave</option>
                              <option>Sick Leave</option>
                              <option>Medical Leave</option>
                              <option>Maternity/Paternity Leave</option>
                              <option>Unpaid Leave</option>
                              <option>Compensatory Leave</option>
                              <option>Other</option>
                            </select>
                          </div>

                          <div className="col-xl-6">
                            <label htmlFor="leaveDuration" className="form-label">Leave Duration</label>
                            <select className="form-select" id="leaveDuration">
                              <option selected={true} disabled={true}>Select Duration</option>
                              <option>Full Day</option>
                              <option>Half Day (Morning)</option>
                              <option>Half Day (Afternoon)</option>
                              <option>Multiple Days</option>
                            </select>
                          </div>

                          <div className="col-xl-6">
                            <label className="form-label">Start Date</label>
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-text text-muted">
                                  <i className="ri-calendar-line" />
                                </div>
                                <input type="text" className="form-control flatpickr-input" id="startDate" placeholder="Select start date" readOnly />
                              </div>
                            </div>
                          </div>

                          <div className="col-xl-6">
                            <label className="form-label">End Date</label>
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-text text-muted">
                                  <i className="ri-calendar-line" />
                                </div>
                                <input type="text" className="form-control flatpickr-input" id="endDate" placeholder="Select end date" readOnly />
                              </div>
                            </div>
                          </div>

                          <div className="col-xl-12">
                            <label htmlFor="leaveReason" className="form-label">Reason for Leave</label>
                            <textarea className="form-control" id="leaveReason" rows={3} placeholder="Please specify the reason for leave" />
                          </div>

                          <div className="col-xl-12">
                            <label htmlFor="documentUpload" className="form-label">Supporting Document (if
                              any)</label>
                            <input className="form-control" type="file" id="documentUpload" />
                            <div className="form-text">Upload medical certificate or other supporting
                              documents</div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" className="btn btn-primary">Submit Leave Request</button>
                      </div>
                    </div>
                  </div>
                </div>
                { /* create leaves model end */}


                { /* leaves edit model start */}
                <div className="modal fade" id="editLeaves" tabIndex={-1} aria-labelledby="editLeavesLabel" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h1 className="modal-title fs-16" id="editLeavesLabel">Edit Leaves</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                      </div>
                      <div className="modal-body">
                        <div className="row gy-15">
                          <div className="col-xl-12">
                            <div className="text-center">
                              <div className="avatar avatar-xxl radius-100">
                                <img src="assets/images/avatar/avatar-thumb-001.webp" alt="Employee Photo" id="profileImageTwo" className="radius-100" />
                                <span className="badge rounded-pill bg-primary avatar-badge">
                                  <input type="file" name="photo" className="p-absolute z-3 cursor-pointer w-100 h-100 op-0 pl-0 pr-0" id="profileImageChangeTwo" />
                                  <i className="ri-camera-line p-relative z-1" />
                                </span>
                              </div>
                              <span className="d-block fw-5 text-muted">Employee Photo</span>
                            </div>
                          </div>

                          <div className="col-xl-12">
                            <label htmlFor="employeeSelect2" className="form-label">Employee</label>
                            <select className="employeeListTwo form-control" id="employeeSelect2">
                              <option value="p-1">John Doe (EMP-1001)</option>
                              <option value="p-2">Jane Smith (EMP-1002)</option>
                              <option value="p-3">Sarah Johnson (EMP-1003)</option>
                              <option value="p-4">Michael Brown (EMP-1004)</option>
                              <option value="p-5">Emily Davis (EMP-1005)</option>
                              <option value="p-6">Robert Wilson (EMP-1006)</option>
                            </select>
                          </div>

                          <div className="col-xl-6">
                            <label htmlFor="leaveType2" className="form-label">Leave Type</label>
                            <select className="form-select" id="leaveType2">
                              <option selected={true} disabled={true}>Select Leave Type</option>
                              <option>Annual Leave</option>
                              <option>Sick Leave</option>
                              <option>Medical Leave</option>
                              <option>Maternity/Paternity Leave</option>
                              <option>Unpaid Leave</option>
                              <option>Compensatory Leave</option>
                              <option>Other</option>
                            </select>
                          </div>

                          <div className="col-xl-6">
                            <label htmlFor="leaveDuration2" className="form-label">Leave Duration</label>
                            <select className="form-select" id="leaveDuration2">
                              <option disabled={true}>Select Duration</option>
                              <option>Full Day</option>
                              <option>Half Day (Morning)</option>
                              <option>Half Day (Afternoon)</option>
                              <option selected={true}>Multiple Days</option>
                            </select>
                          </div>

                          <div className="col-xl-6">
                            <label className="form-label">Start Date</label>
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-text text-muted">
                                  <i className="ri-calendar-line" />
                                </div>
                                <input type="text" className="form-control flatpickr-input" id="startDateTwo" value="15 Jul 2024" readOnly />
                              </div>
                            </div>
                          </div>

                          <div className="col-xl-6">
                            <label className="form-label">End Date</label>
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-text text-muted">
                                  <i className="ri-calendar-line" />
                                </div>
                                <input type="text" className="form-control flatpickr-input" id="endDateTwo" value="18 Jul 2024" readOnly />
                              </div>
                            </div>
                          </div>

                          <div className="col-xl-12">
                            <label htmlFor="leaveReason2" className="form-label">Reason for Leave</label>
                            <textarea className="form-control" id="leaveReason2" rows={3}>Please specify the reason for leave</textarea>
                          </div>

                          <div className="col-xl-12">
                            <label htmlFor="documentUpload2" className="form-label">Supporting Document (if
                              any)</label>
                            <input className="form-control" type="file" id="documentUpload2" />
                            <div className="form-text">Upload medical certificate or other supporting
                              documents</div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" className="btn btn-primary">Save changes</button>
                      </div>
                    </div>
                  </div>
                </div>
                { /* leaves edit model end */}
              </>
            )}

            {hasModule('Payroll') && (
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header justify-between">
                      <h4 className="d-flex-items gap-10">Recent Leave Requests <span className="badge bg-label-primary">{dashboardData.recent_payroll_requests?.length}</span></h4>
                    </div>
                    <div className="card-body pt-15">
                      <div className="table-responsive">
                        <table className="table w-100 text-nowrap" id="employeeAttendanceTable">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Employee</th>
                              <th>Leave Type</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Days</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dashboardData.recent_payroll_requests?.map((leave) => (
                              <tr key={leave.id}>
                                <td>{leave.id}</td>
                                <td>{leave.employee_name}</td>
                                <td className="text-capitalize">{leave.leave_type}</td>
                                <td>{new Date(leave.start_date).toLocaleDateString()}</td>
                                <td>{new Date(leave.end_date).toLocaleDateString()}</td>
                                <td>{leave.duration}</td>
                                <td>
                                  <span className={`badge bg-label-${leave.status === 'approved' ? 'success' : leave.status === 'pending' ? 'warning' : 'danger'}`}>
                                    {leave.status.charAt(0).toUpperCase() + leave.status.slice(1)}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex-items gap-10">
                                    <button className="btn-icon btn-success-light" type="button" data-bs-toggle="modal" data-bs-target="#viewLeaves" onClick={() => setSelectedLeave(leave)}>
                                      <FaEye />
                                    </button>
                                    <button className="btn-icon btn-info-light" type="button" data-bs-toggle="modal" data-bs-target="#editLeaves">
                                      <FaPencilAlt />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {hasModule('Payroll') && (
              <>


              </>
            )}
          </div>

          { /* consolidated leaves details modal */}
          <div className="modal fade" id="viewLeaves" tabIndex={-1} aria-labelledby="viewLeavesLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-16" id="viewLeavesLabel">View Leave Details</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                </div>
                <div className="modal-body">
                  {selectedLeave ? (
                    <div className="row gy-15">
                      <div className="col-xl-12">
                        <div className="text-center">
                          <div className="avatar avatar-xxl radius-100 bg-primary-transparent text-primary text-uppercase mb-3">
                            {selectedLeave.employee_name ? selectedLeave.employee_name[0] : 'U'}
                          </div>
                          <h4 className="mb-0">{selectedLeave.employee_name}</h4>
                          <span className="d-block text-muted fs-12">{selectedLeave.employee_id}</span>
                          <span className={`badge bg-label-${selectedLeave.status === 'approved' ? 'success' : selectedLeave.status === 'pending' ? 'warning' : 'danger'} mt-10`}>
                            {selectedLeave.status.charAt(0).toUpperCase() + selectedLeave.status.slice(1)}
                          </span>
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table">
                          <tbody>
                            <tr className="text-start">
                              <th className="fw-600 text-muted" scope="row" style={{ width: "40%" }}>Email</th>
                              <td>{selectedLeave.employee_email}</td>
                            </tr>
                            <tr className="text-start">
                              <th className="fw-600 text-muted" scope="row">Department</th>
                              <td>{selectedLeave.department_name}</td>
                            </tr>
                            <tr className="text-start">
                              <th className="fw-600 text-muted" scope="row">Leave Type</th>
                              <td className="text-capitalize">{selectedLeave.leave_type}</td>
                            </tr>
                            <tr className="text-start">
                              <th className="fw-600 text-muted" scope="row">Duration</th>
                              <td>{selectedLeave.duration} day(s)</td>
                            </tr>
                            <tr className="text-start">
                              <th className="fw-600 text-muted" scope="row">Period</th>
                              <td>
                                {formatDate(selectedLeave.start_date)} - {formatDate(selectedLeave.end_date)}
                              </td>
                            </tr>
                            <tr className="text-start">
                              <th className="fw-600 text-muted" scope="row">Reason</th>
                              <td>{selectedLeave.reason}</td>
                            </tr>
                            <tr className="text-start">
                              <th className="fw-600 text-muted" scope="row">Request Date</th>
                              <td>{formatDate(selectedLeave.created_at)}</td>
                            </tr>
                            {selectedLeave.responded_by && (
                              <>
                                <tr className="text-start">
                                  <th className="fw-600 text-muted" scope="row">Responded By</th>
                                  <td>{selectedLeave.responded_by}</td>
                                </tr>
                                <tr className="text-start">
                                  <th className="fw-600 text-muted" scope="row">Response Message</th>
                                  <td>{selectedLeave.response_message}</td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center p-20">No leave data selected.</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImmediateManagerDashboard